/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminGetCoursesOptions, AdminGetCoursesResponses } from '../../models/AdminGetCourses'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Courses
 * {@link /admin/courses}
 */
export function adminGetCourses<ThrowOnError extends boolean = true>(options: Options<AdminGetCoursesOptions, ThrowOnError> = {}): Promise<UnwrappedResult<AdminGetCoursesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/admin/courses', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminGetCoursesResponses, ThrowOnError>>
}
